module.exports = __webpack_public_path__ + "img/Receive_bg02@3x.8517b171.png";